import css from 'styled-jsx/css'

export const InputStyle = css`

input.xs,
textarea.xs {
    width: 25%
}

input.sm,
textarea.sm {
    width: 50%
}

input.md,
textarea.md {
    width: 75%
}

input.lg,
textarea.lg {
    width: 100%
}

input {
  max-height: 100%;
}

:global(.form-control) {
  height: calc(1.75rem + 2px) !important;
  line-height: var(--inputLineHeight);
  font-size: var(--inputFontSize);
}

textarea {
  height: 100%;
}

.suffix {
  order: 3
}
.left {
  order: 1
}
`
